@if (monthRange) {
  <dl class="row">
    <dt class="col-sm-1">{{ label }}:</dt>
    <dd class="col-sm-11">
      @if (monthRange.fromMonth && monthRange.toMonth) {
        {{ monthRange.fromMonth }}/{{ monthRange.fromYear }} to {{ monthRange.toMonth }}/{{ monthRange.toYear }}
      }
      @if (monthRange.fromMonth && !monthRange.toMonth) {
        Starting {{ monthRange.fromMonth }}/{{ monthRange.fromYear }}
      }
      @if (!monthRange.fromMonth && monthRange.toMonth) {
        Ending {{ monthRange.toMonth }}/{{ monthRange.toYear }}
      }
    </dd>
  </dl>
}
